import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ContentParagraph } from '../../_lib/components/ContentParagraph';
import { Strong, StrongModifier } from '../../components/atoms/Strong/Strong';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PageManagementActions } from '../../_lib/components/PageManagementActions';
import { PagePublicationInfo } from '../../_lib/components/PagePublicationInfo/PagePublicationInfo';
import { PagePublicationInfoText } from '../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoText';
import { PagePublicationInfoButtons } from '../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoButtons';
import { Dfn } from '../../_lib/components/Dfn/Dfn';

type PageValidityExpiredInfoProps = {
  views: PageManagementActions;
};

function PageValidityExpiredInfo(props: Readonly<PageValidityExpiredInfoProps>) {
  const { t } = useSonTranslation('PageValidityExpiredInfo');

  return (
    <PagePublicationInfo headline={t('headline')}>
      <PagePublicationInfoText>
        <ContentParagraph>
          <Dfn>
            <Strong modifier={StrongModifier.FONT_COLOR_RED}>{t('glossary:instruction')}: </Strong>
          </Dfn>
          {t('expired')}
        </ContentParagraph>
      </PagePublicationInfoText>
      <PagePublicationInfoButtons>
        <PageManagementActions {...props.views} />
      </PagePublicationInfoButtons>
    </PagePublicationInfo>
  );
}

export const PageValidityExpiredInfoBlock = asFetchableBlock(
  PageValidityExpiredInfo,
  BlockType.pagevalidityexpiredinfo
);
export type PageValidityExpiredInfoBlock = ComponentProps<typeof PageValidityExpiredInfoBlock>;
